import { render, staticRenderFns } from "./SchedulerComingSoon.vue?vue&type=template&id=44868896"
import script from "./SchedulerComingSoon.vue?vue&type=script&lang=ts"
export * from "./SchedulerComingSoon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports